import axios from "axios";
import React, { useEffect, useState, Suspense } from "react";
import {
  FiCornerDownLeft,
  FiEdit,
  FiLink,
  FiSearch,
  FiTrash2,
} from "react-icons/fi";

import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Collapse,
} from "reactstrap";
import {
  getInventorySupplier,
  getInventoryPurchase,
  getInventoryItems,
} from "../../../../redux/inventory";
import { useNavigate } from "react-router-dom";
import PurchaseForm from "./PurchaseForm";
import PaginatedList from "../PaginatedList";
import InvoiceItemsPopover from "./InvoiceItemsPopover";
import PurchaseFilterForm from "./PurchaseFilterForm";
import { formatDate } from "../../../utils/dateFormatter";
const PurchaseDashboard = React.lazy(() => import("./PurchaseDashboard"));
const Purchase = () => {
  const [showSummary, setShowSummary] = useState(false);
  const itemsList = useSelector((state) => state.inventory);
  const dispatch = useDispatch();
  const { supplierData, purchaseData, itemsData } = itemsList || {};
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;

  const [formData, setFormData] = useState("");
  const [modal, setModal] = useState(false);
  const [modalItems, setModalItems] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState(); // processed to get supplierId if any
  const navigate = useNavigate();
  const [popoverData, setPopoverData] = useState("");
  const toggle = () => setModal(!modal);
  const toggleModalItems = () => setModalItems(!modalItems);
  const [mode, setMode] = useState("");
  const [purchasePaginatedList, setPurchasePaginatedList] = useState([]);
  const [totalPaid, setTotalPaid] = useState(0);
  const [showSpinner, setShowSpinner] = useState(false);
  const [filters, setFilters] = useState({});
  const [refresh, setRefresh] = useState(false);

  // Pass filters from form
  const handleFilter = (newFilters) => {
    setFilters(newFilters);
  };
  const toggleShow = () => setShowSummary(!showSummary);
  const editSupplierHandler = (Data, toggle, type) => {
    alert(`You are in ${type}`);
    console.log("toggle", toggle);
    console.log("type", type);
    console.log("Data", Data);

    toggle();
    setMode(type);
    setFormData(Data);
  };

  const deleteHandler = (item, itemId) => {
    const slno = prompt("Please enter the SL No. to confirm delete");

    if (slno && Number(slno.trim()) === itemId) {
      axios
        .delete(`${process.env.REACT_APP_COLLEGE_ERP_API}delete-purchase`, {
          params: { id: item._id, branch: userData.branch },
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        })
        .then((res) => {
          if (res) {
            setRefresh((prev) => !prev);
            dispatch(
              getInventoryPurchase({
                token: userData.token,
                branch: userData.branch,
              })
            );
          }
        })
        .catch((err) => {
          if (
            (err.response.data &&
              err.response.data.err &&
              err.response.data.err.name === "TokenExpiredError") ||
            err.response.data.message === "Unauthorized"
          ) {
            navigate("/");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("srchData");
            sessionStorage.removeItem("prescriptionHistory");
            sessionStorage.removeItem("rights");
            navigate("/cri-crm");
            return err;
          }
        });
    } else if (slno) {
      alert("Contact No. not matching");
    }
  };
  const supplierNameHandler = (supplierId) => {
    const supplier = supplierData?.find(
      (item) => item.supplierId === supplierId
    );
    if (supplier) return supplier.supplierName;
    return null;
  };
  const handleSearchChange = (e) => {
    const value = e.target.value;
    const lowerValue = value.toLowerCase();

    // Try to find supplier by partial match in supplierName
    const matchedSupplier = supplierData?.find((s) =>
      s.supplierName?.toLowerCase().includes(lowerValue)
    );

    if (matchedSupplier) {
      // If supplier found, set its supplierId as search input
      setSearchValue(matchedSupplier.supplierId);
      setSearchInput(value);
    } else {
      // Else fallback to normal typed value
      setSearchInput(value);
      setSearchValue(value);
    }
  };

  useEffect(() => {
    console.log(itemsData, itemsList);
  }, [itemsData]);

  useEffect(() => {
    if (userData.token && userData.branch)
      dispatch(
        getInventoryItems({
          token: userData.token,
          branch: userData.branch,
        })
      );
  }, [userData.token, userData.branch]);

  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Col md="3" className="text-center">
          <h3>Purchase Details</h3>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <Button
            color="primary"
            size="sm"
            onClick={toggleShow}
            className="m-1"
          >
            {showSummary ? "Hide Summary" : "Show Summary"}
          </Button>
        </Col>
      </Row>
      <Collapse isOpen={showSummary}>
        <div>
          <PurchaseFilterForm onFilter={handleFilter} />
          <Suspense fallback={<div>Loading Purchases...</div>}>
            <PurchaseDashboard
              filters={filters}
              branch={userData.branch}
              token={userData.token}
              supplierData={supplierData}
            />
          </Suspense>
        </div>
      </Collapse>
      <Row>
        <Col md={2} className="pt-4">
          <Button
            color="primary"
            onClick={() => {
              setFormData("");
              toggle();
              setMode("");
            }}
          >
            {" "}
            Purchase Entry
          </Button>
        </Col>

        <Col md={3} className="pt-4">
          {" "}
          <InputGroup className="mb-4">
            <Input
              value={searchInput}
              onChange={handleSearchChange}
              placeholder="Search supplier, invoice ID, item"
            />

            <InputGroupText>
              {" "}
              <FiSearch />
            </InputGroupText>
          </InputGroup>
        </Col>
      </Row>
      <>
        <PaginatedList
          // setPaginatedList={setPaginatedList}
          searchInput={searchValue}
          setShowSpinner={setShowSpinner}
          //    endPoint="invoice-page"
          endPoint2="purchase-pagination"
          // limit={100}
          setPurchasePaginatedList={setPurchasePaginatedList}
          setTotalPaid={setTotalPaid}
          purchaseLimit={100}
          refresh={refresh}
        />
        {!purchasePaginatedList && (
          <Spinner color="primary">
            <span></span>
          </Spinner>
        )}
        {!purchasePaginatedList?.length === 0 && "No Data - "}
      {purchasePaginatedList && purchasePaginatedList.length > 0 && (() => {
  // Calculate total paid
 

  return (
    <>
      {/* Total Paid Display */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: "10px",
          fontWeight: "bold",
          fontSize: "1.1rem",
          color: "#2c3e50",
        }}
      >
        Total Paid:&nbsp;
        <span style={{ color: "green" }}>₹ {totalPaid.toFixed(2)}</span>
      </div>

      {/* Table */}
      <Table responsive striped>
        <thead>
          <tr className="table-secondary">
            <th style={{ width: "70px" }}>Sl No.</th>
            <th style={{ width: "20%" }}>Supplier Name</th>
            <th>Invoice Date</th>
            <th>Invoice No</th>
            <th>Amount Paid</th>
            <th>Payment Mode</th>
            <th>Items</th>
            <th>Return</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {purchasePaginatedList.map((item, id) => {
            const supplierName =
              supplierNameHandler(item?.supplier?.supplierId) || "N/A";
            const invoiceDate = formatDate(item?.paymentDetails?.invoice_date);
            const invoiceId = item?.paymentDetails?.invoice_id || "-";
            const amountPaid =
              typeof item?.paymentDetails?.amount_paid === "number"
                ? item.paymentDetails.amount_paid.toFixed(2)
                : item?.paymentDetails?.amount_paid
                ? parseFloat(item.paymentDetails.amount_paid).toFixed(2)
                : "-";
            const paymentMode = item?.paymentDetails?.payment_mode || "-";
            const invoiceItems = Array.isArray(item?.invoice)
              ? item.invoice
              : [];

            return (
              <tr key={id}>
                <td style={{ textAlign: "center" }}>{id + 1}</td>
                <td style={{ width: "200px" }}>{supplierName}</td>
                <td>{invoiceDate}</td>
                <td>{invoiceId}</td>
                <td>{amountPaid}</td>
                <td>{paymentMode}</td>
                <td>
                  <FiLink
                    style={{ cursor: "pointer" }}
                    id={`invoiceItems-${id}`}
                    type="button"
                    onClick={() => setPopoverData(invoiceItems)}
                  />
                  <InvoiceItemsPopover
                    targetId={`invoiceItems-${id}`}
                    items={invoiceItems}
                  />
                </td>
                <td>
                  <FiCornerDownLeft
                    id="returnMode"
                    className="ms-2"
                    color="blue"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      editSupplierHandler(item, toggle, "Return Mode")
                    }
                  />
                </td>
                <td>
                  {(userData.rights === "SuperAdmin" ||
                    userData.rights === "Manager" ||
                    userData.rights === "Accounts") && (
                    <FiEdit
                      color="green"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        editSupplierHandler(item, toggle, "Edit Mode")
                      }
                    />
                  )}
                </td>
                <td>
                  {(userData.rights === "SuperAdmin" ||
                    userData.rights === "Manager" ||
                    userData.rights === "Accounts") && (
                    <FiTrash2
                      color="red"
                      style={{ cursor: "pointer" }}
                      onClick={() => deleteHandler(item, id + 1)}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
})()}

      </>
      <Modal
        isOpen={modal}
        toggle={toggle}
        fullscreen
        style={{ maxWidth: "100%" }}
      >
        <ModalHeader toggle={toggle}>{mode}</ModalHeader>
        <ModalBody>
          <PurchaseForm
            editFormData={formData}
            togglePurchaseEntry={toggle}
            mode={mode}
            itemsData={itemsData}
          />
        </ModalBody>
        <ModalFooter>
          <button onClick={toggle}>Close</button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default Purchase;
